var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('Navbar'),_vm._v(" "),_c('Filters'),_vm._v(" "),_c('TripsTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }